import { render } from "./resultTable.vue?vue&type=template&id=71671e3b"
import script from "./resultTable.vue?vue&type=script&lang=js"
export * from "./resultTable.vue?vue&type=script&lang=js"

import "./resultTable.vue?vue&type=style&index=0&id=71671e3b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__